import { MessageCircle } from 'lucide-react'
import { useHistory } from 'react-router'
import { semImagem } from 'assets/svg'
import { formatIsoDateToDisplay } from '../../../utils/formatters'
import { Badge } from '../../../new-components/atoms/Badge'
import { getStatusColor } from '../statusTone'
import { UserOrder } from '../types'

const currency = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' })

interface OrderCardMobileProps {
  order: UserOrder
}

/** Versão em card da linha da tabela, usada abaixo de md (768px). */
export default function OrderCardMobile({ order }: OrderCardMobileProps) {
  const history = useHistory()
  const { status, items_summary: items } = order

  return (
    <li className="flex flex-col gap-3 rounded-lg bg-gray-50 p-4">
      <div className="flex items-start gap-3">
        <img
          src={items?.first_product_image || semImagem}
          alt=""
          loading="lazy"
          className="h-12 w-12 shrink-0 rounded-full border border-solid border-gray-200 bg-white object-contain p-1"
        />

        <div className="flex min-w-0 flex-1 flex-col gap-0.5">
          <span className="text-sm font-semibold text-black">#{order.id}</span>
          {order.is_weight_loss_program && (
            <Badge variant="primary_light" size="xs" className="w-fit">
              Programa Perda de Peso
            </Badge>
          )}
          {items?.first_product_name && (
            <span className="truncate text-xs text-gray-500" title={items.first_product_name}>
              {items.first_product_name}
            </span>
          )}
          {!!items?.count && (
            <span className="text-xs text-gray-500">
              {items.count} {items.count === 1 ? 'item' : 'itens'}
            </span>
          )}
        </div>

        <span className="shrink-0 text-sm font-semibold text-black">{currency.format(Number(order.amount) || 0)}</span>
      </div>

      <dl className="flex flex-col gap-1.5 text-xs">
        <div className="flex justify-between gap-2">
          <dt className="text-gray-500">Data da compra</dt>
          <dd className="text-black">{formatIsoDateToDisplay(order.payments?.[0]?.createdAt ?? order.createdAt)}</dd>
        </div>

        <div className="flex justify-between gap-2">
          <dt className="text-gray-500">Status</dt>
          <dd className="flex flex-col items-end">
            {status?.translated_name ? (
              <>
                <span className="flex items-center gap-2 text-black">
                  <span
                    className="inline-block h-2 w-2 shrink-0 rounded-full"
                    style={{ backgroundColor: getStatusColor(status.status) }}
                  />
                  {status.translated_name}
                </span>
                {status.date && <span className="text-gray-500">em {formatIsoDateToDisplay(status.date)}</span>}
                {status.is_partial && (
                  <span className="text-gray-500">
                    {status.packages_delivered} de {status.packages_total} entregues
                  </span>
                )}
              </>
            ) : (
              <span className="text-gray-400">—</span>
            )}
          </dd>
        </div>
      </dl>

      <div className="flex gap-2">
        <button
          type="button"
          onClick={() => history.push(`?pagina=pedidos-todos&ajuda=${order.id}`)}
          className="flex flex-1 items-center justify-center gap-1.5 rounded-md border-[0.5px] border-solid border-green-700 bg-transparent px-3 py-2 text-xs font-normal text-green-700">
          <MessageCircle size={14} />
          Pedir ajuda
        </button>

        <button
          type="button"
          onClick={() => history.push(`/detalhes-do-pedido/${order.id}`)}
          className="flex-1 rounded-md border-[0.5px] border-solid border-black bg-transparent px-3 py-2 text-xs font-normal text-black">
          Ver detalhes
        </button>
      </div>
    </li>
  )
}
